/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  // Simple confetti animation function
  function createConfetti() {
    const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#6c5ce7', '#ff9ff3'];
    const confettiCount = 50;
    
    for (let i = 0; i < confettiCount; i++) {
      const confetti = document.createElement('div');
      confetti.style.position = 'fixed';
      confetti.style.width = '10px';
      confetti.style.height = '10px';
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.left = Math.random() * window.innerWidth + 'px';
      confetti.style.top = '-10px';
      confetti.style.zIndex = '10000100';
      confetti.style.pointerEvents = 'none';
      confetti.style.borderRadius = Math.random() > 0.5 ? '50%' : '0';
      confetti.style.transform = `rotate(${Math.random() * 360}deg)`;
      
      document.body.appendChild(confetti);
      
      // Animate the confetti falling
      const fallDuration = Math.random() * 3000 + 2000; // 2-5 seconds
      const horizontalDrift = (Math.random() - 0.5) * 200; // Random horizontal movement
      
      confetti.animate([
        {
          transform: `translateY(0px) translateX(0px) rotate(0deg)`,
          opacity: 1
        },
        {
          transform: `translateY(${window.innerHeight + 20}px) translateX(${horizontalDrift}px) rotate(720deg)`,
          opacity: 0
        }
      ], {
        duration: fallDuration,
        easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      });
      
      // Remove confetti after animation
      setTimeout(() => {
        if (confetti.parentNode) {
          confetti.parentNode.removeChild(confetti);
        }
      }, fallDuration);
    }
  }

  // Track cart state to only show confetti on actual additions
  let previousCartItemCount = 0;
  let isInitialLoad = false;

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      
      const currentCartItemCount = cart.item_count || 0;
      // Only trigger confetti and open drawer if item count increased and it's not the initial page load
      if (!isInitialLoad && currentCartItemCount > previousCartItemCount) {
        createConfetti();
        
        // Open cart drawer
        const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (cartDrawer) {
          // Add a small delay to allow the cart drawer to re-render its contents
          // before being opened. This helps prevent race conditions where the
          // drawer opens before the new item is visible.
          setTimeout(() => {
            cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
              bubbles: true
            }));
          }, 250);
        }
      }
      
      previousCartItemCount = currentCartItemCount;
      isInitialLoad = false;
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  
  /*
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  */

  // Native JavaScript QuickView Implementation
  class ProductQuickView {
    constructor(productId, handle, element) {
      this.productId = productId;
      this.handle = handle;
      this.element = element;
      this.state = 'initial'; // 'initial', 'loading'
      this.modal = null;
      this.modalContent = null;
      this.modalScroll = null;
      this.scrollLockEnable = true;
      this.windowH = window.innerHeight;
      
      // Event handler references for proper cleanup
      this.resizeHandler = null;
      this.modalCloseHandler = null;
      this.toggleClickHandler = null;
      this.buttonClickHandler = null;
      this.cartSuccessHandler = null;
      this.cartErrorHandler = null;
      this.productForm = null;
      
      this.init();
    }
    
    init() {
      // Find or create modal
      this.setupModal();
      
      // Bind click handler with proper reference for cleanup
      const button = this.element.querySelector('[data-quickview-button]');
      
      if (button) {
        this.buttonClickHandler = (e) => {
          e.preventDefault();
          this.clickQuickviewButton();
        };
        button.addEventListener('click', this.buttonClickHandler);
        this.button = button; // Store button reference for cleanup
      }
    }
    
    setupModal() {
      const quickviewHolder = this.element.querySelector(`[data-quickview-holder="${this.productId}"]`);
      
      if (quickviewHolder) {
        const modalTemplate = quickviewHolder.querySelector('[data-quickview-modal-template]');
        this.modal = document.querySelector(`[data-quickview-modal][id="${this.productId}"]`);
        
        if (modalTemplate && !this.modal) {
          const modalTemplateInner = modalTemplate.innerHTML;
          const htmlObject = document.createElement('div');
          htmlObject.innerHTML = modalTemplateInner;
          const modalHtml = htmlObject.querySelector('[data-quickview-modal]');
          
          if (modalHtml) {
            document.body.appendChild(modalHtml);
            this.modal = document.querySelector(`[data-quickview-modal][id="${this.productId}"]`);
          }
        }
      }
    }
    
    clickQuickviewButton() {
      console.log('🚀 Quickview button clicked for product:', this.productId);
      console.log('🎯 Product handle:', this.handle);
      
      if (this.modal) {
        this.modal.id = this.productId;
      }
      
      if (document.documentElement.hasAttribute('data-scroll-locked')) {
        this.scrollLockEnable = false;
      }
      
      this.setState('loading');
      this.getQuickviewHTML();
    }
    
    setState(newState) {
      this.state = newState;
      
      // Update button states
      const button = this.element.querySelector('[data-quickview-button]');
      if (button) {
        button.classList.toggle('loading', newState === 'loading');
        button.disabled = newState === 'loading';
      }
    }
    
    async getQuickviewHTML() {
      try {
        const response = await fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-quickview`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const responseText = await response.text();
        const fresh = document.createElement('div');
        fresh.innerHTML = responseText;
        
        this.modalContent = this.modal.querySelector('[data-product-quickview-ajax]');
        const apiContent = fresh.querySelector('[data-api-content]');
        
        if (this.modalContent && apiContent) {
          console.log('🔄 Setting quickview content...');
          this.modalContent.innerHTML = apiContent.innerHTML;
          console.log('📄 Content set, checking for slideshow elements...');
          
          // Log what slideshow elements we have after content is loaded
          const slideshowElements = this.modalContent.querySelectorAll('[data-product-slideshow]');
          const thumbElements = this.modalContent.querySelectorAll('[data-product-thumbs]');
          console.log('🎠 Slideshow elements found:', slideshowElements.length);
          console.log('👆 Thumb elements found:', thumbElements.length);
          
          // Initialize Media class for slideshow functionality
          this.initializeSlideshow();
        }
        
        this.modalScroll = this.modal.querySelector('[data-drawer-scrolls]');
        
        // Trigger media event
        const images = this.modalContent.querySelector('[data-media-id]');
        if (images) {
          const imagesHolder = document.createElement('div');
          imagesHolder.innerHTML = images.parentElement.innerHTML;
          const quickviewHolder = this.element.querySelector(`[data-quickview-holder="${this.productId}"]`);
          if (quickviewHolder) {
            quickviewHolder.dispatchEvent(new CustomEvent('theme:quickview:media', {
              bubbles: true,
              detail: { media: imagesHolder }
            }));
          }
        }
        
        this.modalCreate();
        this.setState('initial');
        
      } catch (error) {
        console.error('Quickview error:', error);
        this.setState('initial');
      }
    }
    
    initializeSlideshow() {
      console.log('🎬 initializeSlideshow called');
      console.log('📦 modalContent:', this.modalContent);
      
      // Initialize Media class for slideshow if available and slideshow elements exist
      const slideshow = this.modalContent.querySelector('[data-product-slideshow]');
      console.log('🎯 slideshow element found:', slideshow);
      console.log('🔧 window.Media available:', !!window.Media);
      console.log('🔧 Media available:', typeof Media !== 'undefined');
      
      if (!slideshow) {
        console.warn('⚠️ No slideshow element found');
        return;
      }
      
      // Try to initialize immediately if Media is available
      if (window.Media || typeof Media !== 'undefined') {
        this.attemptMediaInit(slideshow);
      } else {
        // If Media class not available yet, try again after a short delay
        console.log('⏳ Media class not available yet, trying after delay...');
        setTimeout(() => {
          console.log('🔄 Retrying Media class initialization...');
          console.log('🔧 window.Media available (retry):', !!window.Media);
          
          if (window.Media || typeof Media !== 'undefined') {
            this.attemptMediaInit(slideshow);
          } else {
            // Try to manually initialize Flickity as fallback
            console.log('🔧 Falling back to manual Flickity initialization...');
            this.initializeFallbackSlideshow(slideshow);
          }
        }, 500);
      }
    }
    
    attemptMediaInit(slideshow) {
      try {
        console.log('✅ Attempting to initialize Media class...');
        
        // Create a fake section object that the Media class expects
        const fakeSection = {
          container: this.modalContent,
          id: 'quickview-' + this.productId
        };
        console.log('📝 fakeSection:', fakeSection);
        
        // Initialize the Media class for slideshow functionality
        const MediaClass = window.Media || Media;
        this.mediaInstance = new MediaClass(fakeSection);
        console.log('🎉 Media instance created successfully:', this.mediaInstance);
      } catch (error) {
        console.error('❌ Could not initialize slideshow in quickview:', error);
        console.error('📄 Error stack:', error.stack);
        
        // Fallback to manual Flickity initialization
        console.log('🔧 Falling back to manual Flickity initialization...');
        this.initializeFallbackSlideshow(slideshow);
      }
    }
    
    initializeFallbackSlideshow(slideshow) {
      try {
        console.log('🔨 Initializing fallback Flickity slideshow...');
        
        if (typeof Flickity !== 'undefined') {
          const options = {
            autoPlay: false,
            prevNextButtons: false,
            contain: true,
            pageDots: false,
            adaptiveHeight: true,
            accessibility: true,
            wrapAround: true,
            fade: true,
            rightToLeft: window.isRTL || false
          };
          
          this.flickityInstance = new Flickity(slideshow, options);
          console.log('🎉 Fallback Flickity initialized:', this.flickityInstance);
          
          // Initialize thumbnail navigation
          this.initializeThumbs();
          
        } else {
          console.warn('⚠️ Flickity also not available - slideshow will not work');
        }
      } catch (error) {
        console.error('❌ Fallback slideshow initialization failed:', error);
      }
    }
    
    initializeThumbs() {
      const thumbWrapper = this.modalContent.querySelector('[data-product-thumbs]');
      if (!thumbWrapper || !this.flickityInstance) return;
      
      console.log('👆 Initializing thumbnail navigation...');
      
      const thumbImages = thumbWrapper.querySelectorAll('[data-slideshow-thumbnail]');
      thumbImages.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          this.flickityInstance.select(index);
          
          // Update active thumb
          thumbWrapper.querySelector('.is-activated')?.classList.remove('is-activated');
          thumb.classList.add('is-activated');
        });
      });
      
      // Update thumbs when slide changes
      this.flickityInstance.on('change', (index) => {
        thumbWrapper.querySelector('.is-activated')?.classList.remove('is-activated');
        thumbImages[index]?.classList.add('is-activated');
      });
    }
    
    setupCartEventListeners() {
      // Listen for theme's cart events to add quickview-specific behavior
      this.cartSuccessHandler = this.onCartAddSuccess.bind(this);
      this.cartErrorHandler = this.onCartAddError.bind(this);
      
      // Listen for cart popdown events (theme's success event)
      document.addEventListener('theme:cart:popdown', this.cartSuccessHandler);
      
      // Listen for cart errors if theme dispatches them
      document.addEventListener('theme:cart:error', this.cartErrorHandler);
      
      // Also listen for any error events on the form itself
      if (this.productForm) {
        this.productForm.addEventListener('error', this.cartErrorHandler);
      }
    }
    
    onCartAddSuccess(event) {
      // Only handle if this quickview is currently open
      if (!this.modal || !this.modal.classList.contains('drawer--visible')) {
        return;
      }
      
      // Show success state briefly on quickview button
      const button = this.element.querySelector('[data-quickview-button]');
      if (button) {
        button.classList.add('success');
        setTimeout(() => {
          button.classList.remove('success');
        }, 2000);
      }
      
      // Close quickview modal after brief delay to let user see success
      setTimeout(() => {
        this.modalClose();
      }, 1500);
    }
    
    onCartAddError(event) {
      // Only handle if this quickview is currently open
      if (!this.modal || !this.modal.classList.contains('drawer--visible')) {
        return;
      }
      
      // Let the theme handle the error display, but ensure modal stays open
      // so user can see the error and retry
    }
    
    async handleCartAdd(form, button) {
      console.log('🚀 Handling cart add with custom implementation...');
      
      try {
        // Disable button and show loading state
        button.setAttribute('disabled', true);
        button.classList.add('loading');
        
        // Collect form data
        const formData = new FormData(form);
        const formString = new URLSearchParams(formData).toString();
        
        console.log('📦 Form data:', formString);
        
        // Make Cart API request
        const response = await fetch(`${window.theme.routes.cart}/add.js`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formString
        });
        
        if (!response.ok) {
          throw new Error(`Cart add failed: ${response.status}`);
        }
        
        const result = await response.json();
        console.log('✅ Cart add successful:', result);
        
        // Add small delay to ensure server has processed the cart add before refreshing
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // Trigger cart update events like the theme does
        await this.updateCartAfterAdd();
        
        // Show success and close modal
        this.showAddSuccess(button);
        
      } catch (error) {
        console.error('❌ Cart add failed:', error);
        this.showAddError(button, error);
      }
    }
    
    async updateCartAfterAdd() {
      try {
        // Get updated cart data
        const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
        const cart = await cartResponse.json();
        
        // Dispatch cart change event like the theme does
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        
        console.log('🔄 Cart updated and events dispatched');
      } catch (error) {
        console.error('Failed to update cart:', error);
      }
    }
    
    showAddSuccess(button) {
      // Reset button state
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      button.classList.add('success');
      
      console.log('🎉 Showing add success');
      
      // Close quickview after short delay
      setTimeout(() => {
        this.modalClose();
      }, 1500);
    }
    
    showAddError(button, error) {
      // Reset button state
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      button.classList.add('error');
      
      // Show error message
      const errorContainer = button.closest('[data-add-action-wrapper]')?.querySelector('[data-add-action-errors]');
      if (errorContainer) {
        errorContainer.innerHTML = `<p>Error: ${error.message}</p>`;
      }
      
      console.log('❌ Showing add error');
      
      // Reset error state after delay
      setTimeout(() => {
        button.classList.remove('error');
        if (errorContainer) {
          errorContainer.innerHTML = '';
        }
      }, 5000);
    }
    
    modalCreate() {
      if (typeof MicroModal !== 'undefined') {
        // Listen for theme drawer close events
        this.modal.addEventListener('theme:drawer:close', () => {
          console.log('🔄 Theme drawer close event received - closing modal');
          this.modalClose();
        });
        
        // Add escape key support
        this.escapeHandler = (e) => {
          if (e.key === 'Escape' && this.modal.classList.contains('drawer--visible')) {
            console.log('⌨️ Escape key pressed - closing modal');
            this.modal.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
          }
        };
        document.addEventListener('keydown', this.escapeHandler);
        
        MicroModal.show(this.productId, {
          openClass: 'drawer--visible',
          disableScroll: true,
          disableFocus: false,
          awaitCloseAnimation: true,
          awaitOpenAnimation: true,
          onShow: (modal, el, event) => {
            console.log('🔥 Quickview modal opening');
            
            this.quickviewHead = modal.querySelector('[data-quickview-head]');
            this.quickviewFormArea = modal.querySelector('[data-quickview-form-area]');
            this.toggleButton = modal.querySelector('[data-toggle-button]');
            this.toggleForm('loading');
            
            // Initialize ProductAddButton for cart integration
            const addButtonWrapper = modal.querySelector('[data-add-action-wrapper]');
            console.log('🛒 Found add button wrapper:', addButtonWrapper);
            
            // Since ProductAddButton isn't globally accessible, let's trigger the theme's section loading
            if (addButtonWrapper) {
              console.log('🚀 Attempting to trigger theme section loading...');
              
              // Try to manually trigger the theme's productAddSection for our content
              try {
                // Check if we have access to the theme's sections system
                if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections) {
                  console.log('🎯 Found theme sections system, attempting manual initialization...');
                  
                  // Create a fake section container for the modal
                  const fakeSection = {
                    container: modal,
                    id: 'quickview-' + Date.now()
                  };
                  
                  // Try to access the registered productAddSection
                  const registered = window.Shopify.theme.sections.registered;
                  if (registered && registered.product) {
                    console.log('🔍 Found product section, looking for productAddSection...');
                    // The product section contains multiple components including productAddSection
                    // Let's try to manually call the productAddSection.onLoad method
                  }
                } else {
                  console.log('❌ Theme sections system not accessible');
                }
              } catch (error) {
                console.log('❌ Failed to access theme sections:', error);
              }
              
              // Also try the direct approach with timeout to let theme initialize
              setTimeout(() => {
                console.log('🔄 Attempting delayed ProductAddButton check...');
                if (typeof ProductAddButton !== 'undefined') {
                  try {
                    this.productAddButton = new ProductAddButton(addButtonWrapper);
                    console.log('✅ ProductAddButton initialized successfully (delayed)');
                  } catch (error) {
                    console.log('❌ Failed delayed ProductAddButton init:', error);
                  }
                } else {
                  console.log('📝 ProductAddButton still not available after delay');
                }
              }, 100);
              
              // Implement custom cart API integration since ProductAddButton won't initialize
              const addToCartButton = addButtonWrapper.querySelector('[data-add-to-cart]');
              if (addToCartButton) {
                console.log('🛒 Setting up custom cart API integration...');
                
                // Prevent default form submission and handle with Cart API
                addToCartButton.addEventListener('click', (e) => {
                  console.log('🛍️ Add to cart button clicked - intercepting!');
                  
                  // Check if button is disabled (variant unavailable/sold out)
                  if (addToCartButton.disabled || addToCartButton.hasAttribute('disabled')) {
                    console.log('❌ Button is disabled - variant unavailable or sold out');
                    return;
                  }
                  
                  e.preventDefault(); // Stop form submission
                  
                  const form = e.target.closest('form');
                  if (form) {
                    this.handleCartAdd(form, addToCartButton);
                  }
                });
              }
            } else {
              console.log('❌ No [data-add-action-wrapper] found');
            }
            
            // Add resize listener
            this.resizeHandler = () => this.toggleForm('resize');
            document.addEventListener('theme:resize', this.resizeHandler);
            
            this.clickEventToggleForm();
            
            const firstFocus = modal.querySelector('button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
            if (firstFocus) firstFocus.focus();
            
            // Setup close event listeners now that content is loaded
            console.log('🔧 Setting up close event listeners for loaded content');
            const closeElements = modal.querySelectorAll('[data-micromodal-close]');
            console.log('🎯 Found close elements:', closeElements.length);
            
            // Store close element handlers for cleanup
            this.closeElementHandlers = [];
            
            closeElements.forEach(closeElement => {
              const handler = (e) => {
                e.preventDefault();
                console.log('🚪 Close element clicked - dispatching theme drawer close');
                this.modal.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
              };
              
              closeElement.addEventListener('click', handler);
              this.closeElementHandlers.push({ element: closeElement, handler });
            });
            
            this.modalCloseHandler = () => this.modalClose();
            this.modal.addEventListener('theme:quickview:close', this.modalCloseHandler);
            
            document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
              bubbles: true,
              detail: this.modalScroll
            }));
          },
          onClose: (modal, el, event) => {
            console.log('🚪 Modal closing - cleaning up scroll lock');
            
            // Unlock scroll first
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
              bubbles: true
            }));
            
            // Don't prevent default behavior - let MicroModal handle the close
            // Move focus away from modal elements before aria-hidden is set
            if (el && el.focus) {
              el.focus();
            }
            
            // Pause all media
            const allMedia = modal.querySelectorAll('[data-media-slide]');
            allMedia.forEach(media => {
              media.dispatchEvent(new CustomEvent('pause'));
            });
            
            // Cleanup all event listeners
            this.cleanup();
          }
        });
      }
    }
    
    cleanup() {
      // Remove all event listeners to prevent memory leaks
      if (this.resizeHandler) {
        document.removeEventListener('theme:resize', this.resizeHandler);
        this.resizeHandler = null;
      }
      
      if (this.escapeHandler) {
        document.removeEventListener('keydown', this.escapeHandler);
        this.escapeHandler = null;
      }
      
      if (this.modalCloseHandler && this.modal) {
        this.modal.removeEventListener('theme:quickview:close', this.modalCloseHandler);
        this.modalCloseHandler = null;
      }
      
      if (this.toggleClickHandler && this.toggleButton) {
        this.toggleButton.removeEventListener('click', this.toggleClickHandler);
        this.toggleClickHandler = null;
      }
      
      // Clean up button click handler
      if (this.buttonClickHandler && this.button) {
        this.button.removeEventListener('click', this.buttonClickHandler);
        this.buttonClickHandler = null;
        this.button = null;
      }
      
      // Clean up close element handlers
      if (this.closeElementHandlers) {
        this.closeElementHandlers.forEach(({ element, handler }) => {
          element.removeEventListener('click', handler);
        });
        this.closeElementHandlers = null;
      }
      
      // Clean up cart event listeners
      if (this.cartSuccessHandler) {
        document.removeEventListener('theme:cart:popdown', this.cartSuccessHandler);
        this.cartSuccessHandler = null;
      }
      
      if (this.cartErrorHandler) {
        document.removeEventListener('theme:cart:error', this.cartErrorHandler);
        if (this.productForm) {
          this.productForm.removeEventListener('error', this.cartErrorHandler);
        }
        this.cartErrorHandler = null;
      }
      
      // Clear product form reference
      this.productForm = null;
      
      // Clean up Media instance
      if (this.mediaInstance && typeof this.mediaInstance.destroy === 'function') {
        this.mediaInstance.destroy();
      }
      this.mediaInstance = null;
      
      // Clean up ProductAddButton
      if (this.productAddButton && typeof this.productAddButton.unload === 'function') {
        this.productAddButton.unload();
      }
      this.productAddButton = null;
      
      // Clear references
      this.quickviewHead = null;
      this.quickviewFormArea = null;
      this.toggleButton = null;
    }
    
    modalClose() {
      console.log('🔒 Closing quickview modal');
      
      // Unlock scroll when manually closing
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
        bubbles: true
      }));
      
      // Manually hide the drawer since we're bypassing MicroModal's event system
      if (this.modal) {
        this.modal.classList.remove('drawer--visible');
        this.modal.setAttribute('aria-hidden', 'true');
        console.log('✅ Modal hidden - removed drawer--visible class');
      }
      
      // Also call MicroModal.close as fallback
      if (typeof MicroModal !== 'undefined') {
        MicroModal.close(this.productId);
      }
    }
    
    destroy() {
      // Clean up everything and remove modal from DOM
      this.cleanup();
      
      if (this.modal && this.modal.parentNode) {
        this.modal.parentNode.removeChild(this.modal);
      }
      
      // Clear all references
      this.modal = null;
      this.modalContent = null;
      this.modalScroll = null;
    }
    
    toggleForm(event) {
      if (!this.quickviewFormArea || !this.quickviewHead || !this.toggleButton) return;
      
      if (this.windowH === window.innerHeight && event === 'resize') {
        return;
      }
      
      if (!this.toggleButton.classList.contains('hide')) {
        this.toggleButton.classList.add('hide');
      }
      if (!this.quickviewFormArea.classList.contains('is-expanded')) {
        this.quickviewFormArea.classList.add('is-expanded');
      }
      
      if (event === 'resize') {
        this.quickviewFormArea.classList.add('is-expanded');
        this.toggleButton.classList.add('hide');
        this.windowH = window.innerHeight;
      }
      
      setTimeout(() => {
        const imagesVisiblePartOfImages = window.innerHeight - this.quickviewHead.offsetHeight - this.quickviewFormArea.offsetHeight;
        const hasMediumVisiblePart = imagesVisiblePartOfImages < 400 && imagesVisiblePartOfImages > 250;
        const missingVisiblePart = imagesVisiblePartOfImages < 250;
        
        if (hasMediumVisiblePart || missingVisiblePart) {
          this.toggleButton.classList.remove('hide');
          this.toggleButton.classList.add('is-active');
        } else {
          this.toggleButton.classList.add('hide');
        }
        
        if (missingVisiblePart) {
          if (event === 'loading') {
            this.quickviewFormArea.classList.add('loading');
            setTimeout(() => {
              this.quickviewFormArea.classList.remove('loading');
            }, 50);
          }
          this.quickviewFormArea.classList.remove('is-expanded');
          this.toggleButton.classList.remove('is-active');
        } else {
          this.quickviewFormArea.classList.add('is-expanded');
        }
      }, 200);
    }
    
    clickEventToggleForm() {
      if (!this.toggleButton) return;
      
      if (this.toggleClickHandler) {
        this.toggleButton.removeEventListener('click', this.toggleClickHandler);
      }
      
      this.toggleClickHandler = () => {
        this.toggleButton.classList.toggle('is-active');
        this.quickviewFormArea.classList.toggle('is-expanded');
      };
      
      this.toggleButton.addEventListener('click', this.toggleClickHandler);
    }
  }
  
  // Initialize QuickView for all quickview elements
  function initializeQuickViews() {
    const quickviewElements = document.querySelectorAll('[data-quickview-container]');
    
    quickviewElements.forEach(element => {
      const productId = element.dataset.productId;
      const handle = element.dataset.productHandle;
      
      if (productId && handle && !element._quickview) {
        element._quickview = new ProductQuickView(productId, handle, element);
      }
    });
  }
  
  // Cleanup QuickView instances
  function cleanupQuickViews(container = document) {
    const quickviewElements = container.querySelectorAll('[data-quickview-container]');
    
    quickviewElements.forEach(element => {
      if (element._quickview) {
        element._quickview.destroy();
        element._quickview = null;
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeQuickViews);
  } else {
    initializeQuickViews();
  }
  
  // Re-initialize when new content is loaded (for AJAX)
  document.addEventListener('theme:section:loaded', (event) => {
    initializeQuickViews();
  });
  
  // Cleanup when sections are unloaded
  document.addEventListener('theme:section:unload', (event) => {
    if (event.detail && event.detail.container) {
      cleanupQuickViews(event.detail.container);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
